import { getLineHeight, gotoAnchor } from '../../core/libs/ui-helper';

export default class CourseController
{

    constructor ( courseService, diagramService, $translate, $scope = {} )
    {
        'ngInject';
        Object.assign( this, { diagramService, courseService, $translate, $scope } );

        // this.courseService.getDiagramContainer()
        //   .then(data => {
        //     this.diagramData = data[this.diagramId] || {attempts: 0};
        //     // this.diagramData.complete = true;
        //
        //     if (this.diagramData.complete) {
        //       this.autocomlete(true);
        //     }
        //
        //   });
        this.showAnswer = false;
        this.introCounted = false;
        this.unitStart = Date.now()
        this.lastTimeStamp = this.unitStart
        this.submitTitle = 'submit';
        this.isActivePyramidBuilderDemo = false;
        this.hintCount = 0
        this.submitCount = 0
        // this.commonHintCount = 0
        // this.commonSubmitCount = 0
        this.complexExercises = {}
        this.isCompleted = {}
    }

    sendStatistic ( data )
    {
        const finishedTime = Date.now()
        const exerciseNumber = data.diagram.replace( this.exerciseIdsStart, '' )
        const exercise = this.courseData.exercises.find( i => i.name === exerciseNumber.split( '_' )[ 0 ] )
        if ( exercise.isCompleted )
        {
            return
        }
        const isParts = exerciseNumber.includes( '_' )
        // this.commonHintCount += data.hintsUsed
        // this.commonSubmitCount += data.attempts
        if ( isParts )
        {
            const generalExercise = this.complexExercises[ exercise.id ] || {}
            generalExercise.attempts = ( generalExercise.attempts ? generalExercise.attempts : 0 ) + data.attempts
            generalExercise.hintsUsed = ( generalExercise.hintsUsed ? generalExercise.hintsUsed : 0 ) + data.hintsUsed
            generalExercise.rightAnswers = 1
            this.complexExercises[ exercise.id ] = generalExercise

            const exerciseParts = exerciseNumber.split( '_' )[ 1 ].split( '-' )
            if ( exerciseParts[ 0 ] === exerciseParts[ 1 ] )
            {
                const params = {
                    statisticableId: exercise.id,
                    statisticableType: 'Exercise',
                    secondsSpent: Math.floor( ( finishedTime - this.lastTimeStamp ) / 1000 ),
                    completed: true,
                    attempts: generalExercise.attempts,
                    hintsUsed: generalExercise.hintsUsed,
                    rightAnswers: 1
                }
                this.lastTimeStamp = finishedTime
                this.courseService.sendUserStatistic( params )
                exercise.isCompleted = true
                if ( data.userAnswers )
                {
                    const params = {
                        exerciseId: exercise.id,
                        value: JSON.stringify( data.userAnswers )
                    }
                    this.courseService.sendUserAnswers( params )
                    exercise.userAnswers = data.userAnswers
                }
            }
        } else
        {
            const params = {
                statisticableId: exercise.id,
                statisticableType: 'Exercise',
                secondsSpent: Math.floor( ( finishedTime - this.lastTimeStamp ) / 1000 ),
                completed: true,
                attempts: data.attempts || 0,
                hintsUsed: data.hintsUsed || 0,
                rightAnswers: 1
            }
            this.lastTimeStamp = finishedTime
            this.courseService.sendUserStatistic( params )
            exercise.isCompleted = true
            if ( data.userAnswers )
            {
                const params = {
                    exerciseId: exercise.id,
                    value: JSON.stringify( data.userAnswers )
                }
                this.courseService.sendUserAnswers( params )
                exercise.userAnswers = data.userAnswers
            }
            else
            {
                const params = {
                    exerciseId: exercise.id,
                    value: JSON.stringify( data )
                }
                this.courseService.sendUserAnswers( params )
            }


        }
    }

    onFinishExercise ( exId, userAnswer )
    {
        if ( exId === '0' ) return;
        const exercise = this.courseData.exercises.find( item => item.name === exId )
        if ( exercise.isCompleted )
        {
            return
        }
        const finishTime = Date.now()
        const params = {
            statisticableId: exercise.id,
            statisticableType: 'Exercise',
            secondsSpent: Math.floor( ( finishTime - this.lastTimeStamp ) / 1000 ),
            completed: true,
            attempts: this.complexExercises[ exId ].attempts,
            hintsUsed: this.complexExercises[ exId ].hintsUsed,
            rightAnswers: 1
        }
        this.courseService.sendUserStatistic( params )
        this.lastTimeStamp = finishTime
        exercise.isCompleted = true

        if ( userAnswer )
        {
            const params = {
                exerciseId: exercise.id,
                value: JSON.stringify( userAnswer )
            }
            this.courseService.sendUserAnswers( params )
            exercise.userAnswers = userAnswer
        } else if ( this.complexExercises[ exId ].pyramidBuilderAnswer )
        {
            const params = {
                exerciseId: exercise.id,
                value: JSON.stringify( {
                    ...this.complexExercises[ exId ].pyramidBuilderAnswer,
                    fullwordingIntroduction: this.complexExercises[ exId ].fullwordingIntroduction
                } )
            }
            this.courseService.sendUserAnswers( params )
            exercise.userAnswers = userAnswer
        }
    }

    savePyramidBuilderData ( data )
    {
        if ( this.isActivePyramidBuilderDemo ) return;
        this.enablePyramidBuilter = data.exerciseNumber;
        this.pyramidData = data;
    }

    $onDestory ()
    {
        $( window ).off( 'scroll' );
    }

    $onInit ()
    {
        if ( this.userExerciseAnswers && !this.isUnit )
        {
            const interval = setInterval( () =>
            {
                const model = this.userExerciseAnswers[ this.clearDiagramId || this.diagramId.split( '-' )[ 1 ] ]

                if ( model && Object.keys( model ).length )
                {
                    console.log( "model is", this.clearDiagramId || this.diagramId.split( '-' )[ 1 ], model );

                    if ( this.deductiveSpecialModel )
                    {
                        console.log( "deductive model" );
                        Object.keys( model ).forEach( key =>
                        {
                            const element = $( document.querySelector( `#${ this.diagramId } #element_${ model[ key ] }` ) )

                            element.addClass( 'element-list_drop' )
                            element.addClass( `element-list_drop-slot_${ key }` )
                            if ( this.correctElementStyled )
                            {
                                Object.keys( this.correctElementStyled ).forEach( key =>
                                {
                                    element.css( key, this.correctElementStyled[ key ] )
                                } )
                            }

                            element.position( {
                                my: 'center',
                                at: 'center',
                                of: $( `#${ this.diagramId } #slot_${ key }` ),
                                using: function ( position )
                                {
                                    $( this ).animate( position, 0, 'linear' );
                                }
                            } );
                        } )
                    } else if ( this.isSCQ )
                    {
                        this.data.blocks.forEach( block =>
                        {
                            block.userAnswer = model[ block.modelName ]
                            block.model = block.answer
                        } )
                        Object.assign( this.model, model )
                        this.$scope.$apply()
                        setTimeout( () =>
                        {
                            this.showPaperAnswer( this.diagramId )
                            if ( this.isUserAnswerBigger )
                            {
                                this.expandUserAnswer( this.diagramId )
                            }
                            this.$scope.$apply()
                        }, 500 )
                    } else if ( this.isStepDiagram )
                    {
                        this.currentStateNumber = parseInt( model.number.text )
                        Object.assign( this, model )
                        this.changeState()
                        this.$scope.$apply()
                    } else if ( this.fullWordingOfIntroduction )
                    {
                        this.userAnswerInput = model.fullwordingIntroduction
                    } else
                    {
                        Object.assign( this.model, model )
                        this.$scope.$apply()
                    }
                    clearInterval( interval )
                }
            }, 500 )
        }
        if ( this.finishedExercises )
        {
            const interval = setInterval( () =>
            {
                if ( this.diagramComplete )
                {
                    clearInterval( interval )
                    return
                }

                this.diagramComplete = this.finishedExercises[ this.clearDiagramId || this.diagramId.split( '-' )[ 1 ] ]
                if ( this.diagramComplete )
                {
                    this.diagramCompleteOnce = true
                    this.edit = true
                    this.showAnswer = true
                    this.submited = true
                    this.showFixedAnswers = true
                    this.paperAnswer = true
                    this.firstPartCompleted = true
                    this.secondPartCompleted = true
                    this.scrollDone = true
                    this.movePoints = true
                    this.showMintoIntroduction = true
                    this.buttonText = 'VIEW YOUR TEXT'
                    this.isStatic = true
                    clearInterval( interval )
                    if ( this.checkboxes )
                    {
                        Object.assign( this.userAnswers, this.correctAnswers )
                    } else if ( this.radioButtons )
                    {
                        this.userAnswer = this.correctAnswer
                    } else if ( this.radioButtonGroups )
                    {
                        this.userAnswers = _.cloneDeep( this.correctAnswers )
                    } else if ( this.fixedAnswersDiagram )
                    {
                        const input = document.querySelector( `#${ this.diagramId } input[data-answer="true"]` )
                        if ( input )
                        {
                            input.click()
                        }
                        $( `#${ this.diagramId } .element` ).each( function ()
                        {
                            $( this ).draggable( 'disable' );
                        } );
                        this.autocomlete( true )
                    } else if ( this.scqDiagram )
                    {
                        this.data.answers.forEach( item =>
                        {
                            const element = $( document.querySelector( `#${ this.diagramId } .simplest__structure-answer[data-index="${ item.index }"]` ) )

                            element.addClass( 'simplest__structure-answer--dropped' )

                            const target = $( `#${ this.diagramId } .simplest__structure-box-styles[data-index="${ item.index }"]` )
                            element.css( { width: target.width(), height: target.height() } )

                            element.position( {
                                my: 'center',
                                at: 'center',
                                of: $( `#${ this.diagramId } .simplest__structure-box-styles[data-index="${ item.index }"]` ),
                                using: function ( position )
                                {
                                    $( this ).animate( position, 0, 'linear' );
                                }
                            } );
                        } )
                    } else if ( this.isFiveSection )
                    {
                        const parent = document.getElementById( this.diagramId )
                        this.data.answers.forEach( item =>
                        {
                            const elementWithoutJQ = parent.querySelector( `.simplest__structure-answer[data-index="${ item.answer }"]` )
                            const element = $( elementWithoutJQ )

                            element.addClass( 'simplest__structure-answer--dropped' )

                            const target = $( parent.querySelector( `.simplest__structure-box[data-index*="${ item.answer }"]:not(.simplest__structure-box--filled)` ) )
                            element.css( { width: target.width(), height: target.height() } )
                            target.addClass( 'simplest__structure-box--filled' )

                            element.position( {
                                my: 'center',
                                at: 'center',
                                of: target,
                                using: function ( position )
                                {
                                    $( this ).animate( position, 0, 'linear' );
                                }
                            } );

                            // const textBox = elementWithoutJQ.querySelector('.box-title')
                            const lineHeight = getLineHeight( elementWithoutJQ );
                            const rowsAmount = parseInt( Number( element.outerHeight() - lineHeight - 10 ) / lineHeight, 10 );

                            const boxTextBeforeHidden = element.find( '.simplest__box-text' ).outerHeight();

                            // Logic for arrow tooltip in the box
                            if ( boxTextBeforeHidden < ( element.outerHeight() - lineHeight - 10 ) )
                            {
                                element.find( '.simplest__box-text' ).css( { height: '', overflow: '' } );
                                element.find( '.simplest__arrow-button' ).css( { display: 'none', 'justify-content': '' } );
                            } else
                            {
                                element.find( '.simplest__box-text' ).css( { height: rowsAmount * lineHeight, overflow: 'hidden' } );
                                element.find( '.simplest__arrow-button' ).css( { display: 'flex', 'justify-content': 'flex-end' } );
                            }
                        } )
                        setTimeout( () =>
                        {
                            if ( parent.querySelector( '.ui-draggable' ) )
                            {
                                this.diagramService.disableSCQDiagram( this.diagramId );
                            }
                        }, 1000 )
                    } else if ( !this.deductiveSpecialModel && !this.fullWordingOfIntroduction )
                    {
                        this.autocomlete( true )
                    }
                    this.$scope.$apply()
                }
            }, 500 )
        }
        setTimeout( () =>
        {
            if ( this.fixedAnswersDiagram )
            {

                this.movePoints = false;
                this.scrollDone = false;
            }
            if ( this.isUnit )
            {
                if ( !this.courseService.coursesData )
                {
                    this.courseService.getAll().then( () =>
                    {
                        this.courseData = this.courseService.getCourseData()
                        this.courseDataReceived()
                    } )
                } else
                {
                    this.courseData = this.courseService.getCourseData()
                    this.courseDataReceived()
                }
            }
            if ( !this.isUnit && !this.fixedAnswersDiagram )
            {
                return
            }
            $( window ).bind( 'scroll', () =>
            {
                const screenHeight = $( window ).innerHeight();
                if ( !this.scrollDone && this.fixedAnswersDiagram )
                {
                    const firstFixedAnswer = document.querySelector( `#${ this.diagramId } .drag-element` );
                    let firstFixedAnswerPosition = $( firstFixedAnswer ).offset().top - screenHeight + $( firstFixedAnswer ).innerHeight() / 2;
                    if ( window.scrollY >= firstFixedAnswerPosition )
                    {
                        this.scrollDone = true;
                        this.movePoints = true;
                        this.$scope.$apply();
                        setTimeout( () =>
                        {
                            this.showFixedAnswers = true;
                            this.$scope.$apply();
                        }, 1000 );
                    }
                }
                if ( this.isUnit && !this.introCounted && this.courseData )
                {
                    const firstExercisePosition = document.querySelector( '#exercise-1' );
                    const yPosMax = screenHeight * 0.75
                    if ( firstExercisePosition.getClientRects()[ 0 ].y <= yPosMax )
                    {
                        this.lastTimeStamp = Date.now()
                        this.introCounted = true
                        this.courseData.isCompleted = true

                        const params = {
                            statisticableId: this.courseData.id,
                            statisticableType: 'UnitIntro',
                            secondsSpent: Math.floor( ( this.lastTimeStamp - this.unitStart ) / 1000 ),
                            completed: true,
                            attempts: 0,
                            hintsUsed: 0,
                            rightAnswers: 0
                        }
                        this.courseService.sendUserStatistic( params )
                    }
                }
            } );
        }, 500 )
    }

    onSectionFinish ()
    {
        // if (this.courseData.isCompleted) {
        //   return
        // }
        // const params = {
        //   statisticableId: this.courseData.unit_id,
        //   statisticableType: 'Unit',
        //   secondsSpent: Math.floor((Date.now() - this.unitStart) / 1000),
        //   completed: true,
        //   attempts: this.commonSubmitCount,
        //   hintsUsed: this.commonHintCount,
        //   rightAnswers: 0
        // }
        // this.courseService.sendUserStatistic(params)
        this.courseData.isCompleted = true
    }

    $onDestroy ()
    {
        $( window ).unbind( 'scroll' );
    }

    courseDataReceived ()
    {
        const countCompleted = () =>
        {
            this.courseData.exercises.forEach( i =>
            {
                this.isCompleted[ i.name ] = i.isCompleted
                if ( this.exerciseUserAnswers )
                {
                    this.exerciseUserAnswers[ i.name ] = i.userAnswers
                }
                if ( this.highlightWords )
                {
                    this.highlightWords[ 'ex' + i.name ] = i.isCompleted
                }
            } )
        }

        if ( !this.introCounted )
        {
            this.introCounted = this.courseData.isCompleted
        }
        countCompleted()
        this.$scope.$watch( 'courseData', countCompleted, true )
        if ( this.isUnitFive )
        {
            if ( this.isCompleted[ '1' ] )
            {
                this.exercise2Show = true
                if ( this.exerciseUserAnswers[ '1' ] )
                {
                    this.defineScqAnswers( 'exercise2', {
                        x: {
                            scq: this.exerciseUserAnswers[ '1' ]
                        }
                    }, 'x', true )
                }
            }
            if ( this.isCompleted[ '2' ] )
            {
                this.exercise4Show = true
                if ( this.exerciseUserAnswers[ '2' ] )
                {
                    this.defineScqAnswers( 'exercise4', {
                        x: {
                            scq: this.exerciseUserAnswers[ '2' ]
                        }
                    }, 'x', true )
                }
            }
            if ( this.isCompleted[ '3' ] )
            {
                this.exercise6Show = true
                if ( this.exerciseUserAnswers[ '3' ] )
                {
                    this.defineScqAnswers( 'exercise6', {
                        x: {
                            scq: this.exerciseUserAnswers[ '3' ]
                        }
                    }, 'x', true )
                }
            }
            if ( this.isCompleted[ '4' ] )
            {
                this.exercise8Show = true
                if ( this.exerciseUserAnswers[ '4' ] )
                {
                    this.defineScqAnswers( 'exercise8', {
                        x: {
                            scq: this.exerciseUserAnswers[ '4' ]
                        }
                    }, 'x', true )
                }
            }
            this.$scope.$apply();
        }
    }

    autocomlete ( instant )
    {
        this.courseService.play( 'buttonClick' );
        this.onHold = true;
        this.diagramService.autocomplete( this.diagramId, instant )
            .then( () =>
            {
                this.onHold = false;
                this.diagramComplete = true;
                this.diagramCompleteOnce = true;
                this.courseService.play( 'exerciseComplete' );
                this.finishExercise();
            } );
    }

    reset ()
    {
        this.onHold = true;
        this.diagramService.reset( this.diagramId )
            .then( () =>
            {
                this.onHold = false;
                this.diagramComplete = false;
            } );
    }

    hint ()
    {
        this.hintCount++;
        this.courseService.play( 'buttonClick' );
        if ( this.checkboxes )
        {
            this.checkCheckBoxesStatus( true );
        } else if ( this.radioButtons )
        {
            this.checkRadioButtons( this.diagramId );
        } else if ( this.radioButtonGroups )
        {
            this.radioButtonsGroup( this.diagramId );
        } else if ( this.highlightOnlyIncorect )
        {
            const isBoxesCompleted = this.diagramService.highlightOnlyIncorectDragbleBoxes( this.diagramId );
            const isRadiosCompleted = this.diagramService.checkRadioButtons( this.diagramId );
            if ( isBoxesCompleted && isRadiosCompleted )
            {
                this.submit()
            }
        } else
        {
            const isBoxesCompleted = this.diagramService.checkBoxHint( this.diagramId );
            const isRadiosCompleted = this.diagramService.checkRadioButtons( this.diagramId );
            if ( isBoxesCompleted && isRadiosCompleted )
            {
                this.submit()
            }
        }
    }

    hideAnswer ()
    {
        this.showAnswer = false;
        if ( this.greyAnswers )
        {
            const elements = document.querySelectorAll( `#${ this.diagramId } .element-list_drop` );
            $( elements ).css( 'background-color', '#a7dec3' );
        }
    }

    submit ()
    {
        this.submitCount++;
        if ( this.demo )
        {
            this.autocomlete();
        } else if ( this.checkboxes )
        {
            this.checkCheckBoxesStatus();
        } else if ( this.simplist )
        {
            this.showSimplistAnswers();
        } else if ( this.inducivedeductive )
        {
            this.checkInduciveDeductive();
        } else if ( this.radioButtons )
        {
            this.checkRadioButtons();
        } else if ( this.reveal )
        {
            this.showAnswers();
        } else if ( this.radioButtonGroups )
        {
            this.radioButtonsGroup();
        } else if ( this.deductive )
        {
            this.revealDeductive();
        } else if ( this.fixedAnswersDiagram )
        {
            this.submitFixedAnswersDiagram();
        } else
        {
            const diagramComplete = this.diagramService.checkDiagramAnswers( this.diagramId );
            if ( diagramComplete )
            {
                this.diagramComplete = diagramComplete;
                this.courseService.play( 'buttonClick' );
                this.courseService.play( 'exerciseComplete' );
                this.showAnswer = true;
                this.diagramCompleteOnce = true;
                if ( this.greyAnswers )
                {
                    const elements = document.querySelectorAll( `#${ this.diagramId } .element-list_drop` );
                    $( elements ).css( 'background-color', '#7b7b7b' );
                }
                this.finishExercise()
            } else
            {
                this.submitTitle = 'resubmit';
                this.diagramHint = true;
                this.courseService.play( 'wrongAnswer' );
            }
        }
        // this.updateDiagramStatus();
    }

    checkInduciveDeductive ( diagramId )
    {
        const inputChaked = document.querySelectorAll( `#${ this.diagramId } input:checked` )[ 0 ];

        if ( !inputChaked )
        {
            this.courseService.play( 'wrongAnswer' );
            return;
        }

        const isDiagramComplete = this.diagramService.checkDiagramAnswers( this.diagramId );
        const correctCheckbox = inputChaked.getAttribute( 'data-answer' ) == 'true';

        if ( correctCheckbox && isDiagramComplete )
        {
            this.courseService.play( 'buttonClick' );
            this.courseService.play( 'exerciseComplete' );
            this.finishExercise();
            this.diagramCompleteOnce = true;
            this.diagramComplete = true;
        } else
        {
            this.diagramHint = true;
            this.submitTitle = 'resubmit';
            this.courseService.play( 'wrongAnswer' );
        }
    }

    finishExercise ()
    {
        if ( this.deductiveSpecialModel )
        {
            this.model = {};
            const elements = document.querySelectorAll( `#${ this.diagramId } .element-list_drop` )
            elements.forEach( elem =>
            {
                const slotItem = elem.className.split( ' ' ).filter( className => className.startsWith( 'element-list_drop-slot_' ) )[ 0 ].replace( 'element-list_drop-slot_', '' )
                this.model[ slotItem ] = elem.id.replace( 'element_', '' )
            } );
        }
        this.onFinish( {
            $event: {
                diagram: this.diagramId,
                attempts: this.submitCount,
                hintsUsed: this.hintCount,
                rightAnswers: 1,
                userAnswers: this.model
            }
        } );
    }

    next ()
    {
        this.nextClicked = true
        this.courseService.play( 'buttonClick' );
        let nextElement = null;
        if ( $( `#${ this.diagramId }` ).parents( '.diagram' ).next( '.unit-wrapper' ).length )
        {
            nextElement = $( `#${ this.diagramId }` ).parents( '.diagram' ).next( '.unit-wrapper' );
        } else
        {
            if ( $( `#${ this.diagramId }` ).parents( '.diagram' ).parents( '.exercise' ).length )
            {
                nextElement = $( `#${ this.diagramId }` ).parents( '.diagram' ).parents( '.exercise' ).next();
            }
            else
            {
                nextElement = $( `#${ this.diagramId }` ).parents( '.diagram' ).next();
            }
        }

        $( 'html, body' ).animate( {
            scrollTop: nextElement.offset().top,
        }, 300 );
    }

    updateDiagramStatus ()
    {
        this.diagramData.diagramCompleteOnce = this.diagramCompleteOnce;
        this.diagramData.diagramComplete = this.diagramComplete;
        this.diagramData.attempts++;
        // this.courseService.updateDiagramContainer(this.diagramId, this.diagramData);
    }

    checkCheckBoxesStatus ( hint )
    {
        this.diagramService.checkDiagramCheckboxesAnswers( this.userAnswers, this.correctAnswers )
            .then( data =>
            {
                // console.log(data);
                this.diagramComplete = data.complete;
                this.checkBoxMistakes = data.mistake;
                this.checkBoxCorrect = data.correct;

                if ( !this.diagramForm.$pristine )
                {
                    this.diagramHint = true;
                }

                this.correctIndex = data.correctIndex;
                this.incorrectIndex = data.incorrectIndex;

                for ( let k in this.checkBoxMistakes )
                {
                    this.diagramForm[ k ].$setValidity( 'answear', false );
                }

                for ( let k in this.checkBoxCorrect )
                {
                    this.diagramForm[ k ].$setValidity( 'answear', true );
                }

                if ( hint && !this.diagramComplete )
                {
                    this.diagramService.checkBoxHint( this.diagramId, this.checkboxes, this.correctIndex, this.incorrectIndex, this.correctAnswers );
                } else if ( this.diagramComplete )
                {
                    this.courseService.play( 'buttonClick' );
                    this.courseService.play( 'exerciseComplete' );
                    this.finishExercise();
                } else
                {
                    this.courseService.play( 'wrongAnswer' );
                }

            } ).catch( e => console.log( e ) );

    }

    showSimplistAnswers ()
    {
        this.courseService.play( 'buttonClick' );
        this.blocks.forEach( block =>
        {
            if ( block.answer )
            {
                block.userAnswer = block.model;
                block.model = this.$translate.instant( block.answer );
            }
        } );
        this.diagramCompleteOnce = true;
        this.diagramComplete = true;
        this.finishExercise();
    }

    revealDeductive ()
    {
        this.courseService.play( 'exerciseComplete' );
        this.diagramComplete = true;
        this.showAnswer = true;
        this.finishExercise();
    }

    gotoAnchor ( hash )
    {
        gotoAnchor( hash );
    }

    introductionShowNextExercise ( nextExerciseLink, event, exNumber )
    {
        const complexExercises = this.complexExercises[ exNumber ]
        if ( complexExercises )
        {
            complexExercises.fullwordingIntroduction = event.fullwordingIntroduction
            this.onFinishExercise( exNumber )
        }
        this.gotoAnchor( nextExerciseLink );
    }

    showNextExercise ()
    {
        this[ `${ this.nextExercise }Show` ] = true;

        setTimeout( () =>
        {
            this.gotoAnchor( this.nextExerciseLink );
        }, 500 )
    }

    onSubmitScqDiagramDndFramework ( nextExercise, nextExerciseLink, pyramidData )
    {
        this.enablePyramidBuilter = 0;
        this.isActivePyramidBuilderDemo = true;
        this.pyramidData = pyramidData;

        this.nextExercise = nextExercise;
        this.nextExerciseLink = nextExerciseLink;
    }

    onClosePyramidBuilder ( { store, guid, key } )
    {
        if ( !this.isActivePyramidBuilderDemo ) return;
        this.isActivePyramidBuilderDemo = false;
        this.nextExercise && this.defineScqAnswers( this.nextExercise, store, key );
    }

    defineScqAnswers ( exercise, store, key, skitNext = false )
    {
        this[ exercise ].blocks[ 0 ].answer = store[ key ].scq.s;
        this[ exercise ].blocks[ 1 ].answer = store[ key ].scq.c;
        this[ exercise ].blocks[ 2 ].answer = store[ key ].scq.q;
        // working only in <scq-diagram /> for 5A
        if ( this[ exercise ].prefilledAnswer )
        {
            this[ exercise ].blocks[ 0 ].model = store[ key ].scq.s;
            this[ exercise ].blocks[ 1 ].model = store[ key ].scq.c;
            this[ exercise ].blocks[ 2 ].model = store[ key ].scq.q;
        }
        switch ( true )
        {
            case Boolean( store[ key ].scq[ 's-header' ] ):
                this[ exercise ].blocks[ 0 ].note = store[ key ].scq[ 's-header' ];
            case Boolean( store[ key ].scq[ 'c-header' ] ):
                this[ exercise ].blocks[ 1 ].note = store[ key ].scq[ 'c-header' ];
            case Boolean( store[ key ].scq[ 'q-header' ] ):
                this[ exercise ].blocks[ 2 ].note = store[ key ].scq[ 'q-header' ];
        }
        this[ exercise ] = Object.assign( {}, this[ exercise ] );

        !skitNext && this.showNextExercise();
    }

    checkRadioButtons ( hint )
    {
        if ( this.userAnswer === this.correctAnswer )
        {
            this.diagramComplete = true;
        } else
        {
            this.diagramHint = true;
        }

        if ( hint && !this.diagramComplete ) this.diagramService.radioButtonsHint( hint, this.userAnswer, this.correctAnswer );

        if ( this.diagramComplete )
        {
            this.courseService.play( 'buttonClick' );
            this.courseService.play( 'exerciseComplete' )
            this.finishExercise();
        } else if ( !hint )
        {
            this.courseService.play( 'wrongAnswer' );
        }
    }

    radioButtonsGroup ( hint )
    {
        if ( this.userAnswers[ 0 ] === this.correctAnswers[ 0 ] && this.userAnswers[ 1 ] === this.correctAnswers[ 1 ] )
        {
            this.diagramComplete = true;
        } else
        {
            this.diagramHint = true;
        }

        if ( hint && !this.diagramComplete ) this.diagramService.radioButtonsGroupHint( hint, this.userAnswers, this.correctAnswers, `checkboxes-task-${ this.diagramNumber }` );

        if ( this.diagramComplete )
        {
            this.courseService.play( 'buttonClick' );
            this.courseService.play( 'exerciseComplete' )
            this.finishExercise();
        } else if ( !hint )
        {
            this.courseService.play( 'wrongAnswer' );
        }
    }

    onFocusPreFill ()
    {
        this.edit = true;
        setTimeout( () =>
        {
            let element = document.querySelector( `#${ this.diagramId } .pre-filed` );
            element = $( element )
            element.focus()
        }, 200 )
    }

    onBlurPreFill ()
    {
        if (
            this.defaultPrefiled === this.prefiledData ||
            this.defaultPrefiled.substring( 0, this.defaultPrefiled.length - 1 ) === this.prefiledData
        )
        {
            this.edit = false
        }
    }

    showAnswers ()
    {
        this.diagramComplete = true;
        this.showAnswer = true;
        if ( !this.firstPartCompleted )
        {
            this.firstPartCompleted = true;
        } else
        {
            this.secondPartCompleted = true;
        }
        this.courseService.play( 'buttonClick' );
        if ( this.secondPartCompleted || !this.twoRows )
        {
            this.courseService.play( 'exerciseComplete' );
            this.finishExercise();
        }
        if ( this.greyAnswers )
        {
            const elements = document.querySelectorAll( `#${ this.diagramId } .element-list_drop` );
            $( elements ).css( 'background-color', '#7b7b7b' );
        }
    }

    submitFixedAnswersDiagram ()
    {
        const diagramComplete = this.diagramService.checkFixedAnswersDiagram( this.diagramId );
        const reasoning = Array.from( document.querySelectorAll( `#${ this.diagramId } input` ) );
        const rightReasoning = reasoning.some( input => ( input.dataset.answer === 'true' ) && input.checked );
        if ( diagramComplete && rightReasoning )
        {
            this.diagramComplete = diagramComplete;
            this.courseService.play( 'buttonClick' );
            this.courseService.play( 'exerciseComplete' );
            this.showAnswer = true;
            this.diagramCompleteOnce = true;
            this.finishExercise();
        } else
        {
            this.submitTitle = 'resubmit';
            this.diagramHint = true;
            this.courseService.play( 'wrongAnswer' );
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/course.controller.js